<script setup lang="ts">
const props = defineProps<{
  block: BlockRichText,
  noHorizontalPadding?: boolean,
}>()

const textSizeClass = computed(() => {
  switch (props.block.typeSize) {
    case 'small': return 'text-sm'
    default: return 'text-d'
  }
})
</script>

<template>
  <section v-if="hasRichTextContent(block.richText)" class="container-d my-3" :class="{ 'px-1': !noHorizontalPadding }">
    <core-truncated-rich-text
      v-if="block.truncate"
      :content="block.richText"
      :text-size-class="textSizeClass"
      :word-count="block.wordLimit ?? undefined"
    />
    <core-rich-text
      v-else
      :content="block.richText"
      :text-size-class="textSizeClass"
    />
  </section>
</template>
